module.exports = __webpack_public_path__ + "assets/img/5_1147.5523f7ea.jpg";